import { Link } from "react-router-dom";
import { useAuth } from "../features/auth/useAuth";

export function UnauthorizedPage() {
  const { isAuthenticated, dashboardPath } = useAuth();

  return (
    <main className="app-shell">
      <section className="hero fade-in">
        <p className="eyebrow">403</p>
        <h1>Access denied</h1>
        <p className="subtitle">
          Your account is authenticated, but this route belongs to a different role.
        </p>
        <div className="meta-row">
          <Link className="refresh-btn link-btn" to={isAuthenticated ? dashboardPath : "/login"}>
            {isAuthenticated ? "Go to my dashboard" : "Go to login"}
          </Link>
        </div>
      </section>
    </main>
  );
}
